import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { TabList, TabRoot, TabTrigger } from '../../components/Tabs';
import { FolderInfo } from './folderUtils';

const styleSheet = StyleSheet.create({
	container: {
		marginBottom: 10,
	},
});

interface TemplateFolderTabsProps {
	folders: FolderInfo[];
	selectedFolder: string | null;
	onFolderSelect: (folder: string | null) => void;
}

/**
 * Horizontal tab bar for filtering templates by folder.
 * Renders an "All" tab followed by folder tabs in alphabetical order.
 * Reuses CampaignBrowserTabs styling for consistency.
 */
export const TemplateFolderTabs: React.FC<TemplateFolderTabsProps> = ({ folders, selectedFolder, onFolderSelect }) => {
	// Don't render if no folders exist
	if (folders.length === 0) {
		return null;
	}

	return (
		<div className={css(styleSheet.container)}>
			<TabRoot value={selectedFolder} onValueChange={onFolderSelect}>
				<TabList>
					<TabTrigger value={null}>All</TabTrigger>
					{folders.map(folder => (
						<TabTrigger key={folder.name} value={folder.name}>
							{folder.name}
						</TabTrigger>
					))}
				</TabList>
			</TabRoot>
		</div>
	);
};
